module.exports = new __parcel__URL__("google_en.656b3a53.jpeg").toString();